import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { INITIAL_PAGE_TRANSITION_DURATION } from "../components/InitialPageTransition/InitialPageTransition.js";
export const useIsInitialPageLoad = () => {
    const [isInitialPageLoad, setIsInitialPageLoad] = useState(true);
    const location = useLocation();
    // this effect sets `isInitialPageLoad` to false and makes sure that we do not trigger the initial page transition a second time
    useEffect(() => {
        setTimeout(() => isInitialPageLoad && setIsInitialPageLoad(false), 1000 * INITIAL_PAGE_TRANSITION_DURATION);
    }, [isInitialPageLoad, location]);
    return { isInitialPageLoad };
};
//# sourceMappingURL=useIsFirstMount.js.map